import { render, staticRenderFns } from "./FolderStructure.vue?vue&type=template&id=220d94ed&scoped=true&"
import script from "./FolderStructure.vue?vue&type=script&lang=js&"
export * from "./FolderStructure.vue?vue&type=script&lang=js&"
import style0 from "./FolderStructure.vue?vue&type=style&index=0&id=220d94ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220d94ed",
  null
  
)

export default component.exports